import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@htx/environment';
import { SystemHealth } from './health.model';

@Injectable({
  providedIn: 'root'
})
export class HealthService {
  private httpClient = inject(HttpClient);

  private readonly baseUrl = `${environment.backendUrl}/health`;

  getSystemsHealth(): Observable<SystemHealth[]> {
    return this.httpClient.get<SystemHealth[]>(`${this.baseUrl}/systems`);
  }
}
